// import _ from 'lodash'
import {
  READ_ISSUE_DETAIL,
  // CREATE_ISSUE_DETAIL,
  UPDATE_ISSUE_DETAIL,
  ADD_ISSUE_NOTE,
  RESET_ISSUE_DETAIL,
  // DELETE_ISSUE_DETAIL
} from "../actions";

const issueDetail = (state = [], action) => {
  switch (action.type) {
    case READ_ISSUE_DETAIL:
      // console.log('action: ', action.response.success.issue)
      return action.response.success.issue;
    // case CREATE_ISSUE_DETAIL:
    //   return state
    case UPDATE_ISSUE_DETAIL:
      // console.log('action: ', action)
      // console.log('state: ', state)
      // return state
      return { ...state, ...action.result.issue };
    case ADD_ISSUE_NOTE:
      // console.log('action: ', action)
      // console.log('state: ', state)
      // console.log('journals: ', state.journals)
      state.journals.push({ ...action.result });
      return { ...state };
    // return {...state, ...action.result.issue}
    // case DELETE_ISSUE_DETAIL:
    //   return state
    case RESET_ISSUE_DETAIL:
      return {};
    default:
      return state;
  }
};

export default issueDetail;
